
export default {
  data: ()=>({
    cart: null,
    themeData: window.themeData,
  }),
  computed: {
    products() {
      return this.cart?.products || [];
    },
  },
  methods: {
    async loadCart() {
      var cartId=localStorage.getItem("icCartUuid");
      this.cart=(await appPubApi.request("GET", "cart"+(cartId?"/"+cartId:"")))?.body;
      if (this.cart) {
        localStorage.setItem("icCartUuid", this.cart.uuid);
      }
    },
    cleanCart() {
      localStorage.removeItem("icCartUuid");
    },
    async addProduct(productUuid, quantity) {
      if (!quantity)
        quantity=1;
      if (this.cart?.uuid)
        this.cart=(await appPubApi.request("PUT", "cart/"+this.cart.uuid, {products: [
          {product: productUuid, addQty: quantity},
        ]})).body;
      else {
        this.cart=(await appPubApi.request("POST", "cart", {products: [
          {product: productUuid, addQty: quantity},
        ]})).body;
        if (this.cart) {
          localStorage.setItem("icCartUuid", this.cart.uuid);
        }
      }
    },
    async setProductQty(productUuid, quantity) {
      if (!quantity)
        quantity=1;
      this.cart=(await appPubApi.request("PUT", "cart/"+this.cart.uuid, {products: [
        {product: productUuid, setQty: quantity},
      ]})).body;
    },
    async removeProduct(productUuid) {
      this.cart=(await appPubApi.request("PUT", "cart/"+this.cart.uuid, {products: [
        {product: productUuid, remove: 1},
      ]})).body;
    },
    async removeAll() {
      this.cart=(await appPubApi.request("PUT", "cart/"+this.cart.uuid,
        {products: this.cart.products.map(item=>({product: item.product.uuid, remove: 1}))}
      )).body;
    },
    async addDiscount(discountUuid, quantity) {
      if (!quantity)
        quantity=1;
      this.cart=(await appPubApi.request("PUT", "cart/"+this.cart.uuid, {products: [
        {discount: discountUuid, addQty: quantity},
      ]})).body;
    }
  },
  created() {
    window.appCartWidget=this;
    this.loadCart();
  }
}
